exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox {\n  height: 15px;\n  width: 15px;\n  border: 2px solid #6d6d6d;\n  border-radius: 2px;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  position: static; }\n\n.selected {\n  background-image: url(\"/assets/img/checkbox_checked.png\");\n  background-size: contain; }\n\n.checkbox-text {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  cursor: pointer;\n  padding-left: 2px; }\n\n.checkbox-container {\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/chckbox/chckbox.component.scss
// module id = ../../../../../src/app/core/components/chckbox/chckbox.component.scss
// module chunks = main